import React from 'react';
import './GenderBlog.css';
import renderHTML from 'react-render-html';
import axios from 'axios';
import {Link} from '@reach/router';

class GenderBlog extends React.Component{

    
    constructor (props) {
        super (props);
        this.state = {
            loading: false,
            posts: [],
            error: ''
        }
    }

    componentDidMount() {
        const wordPressSiteURL='http://localhost/finalyearproject';
        this.setState( { loading: true }, () => {
            axios.get( `${wordPressSiteURL}/wp-json/wp/v2/gender/ `)
              .then( res => {
                if ( res.data.length ) {
                  this.setState( { loading: false, posts: res.data } );
                } else {
                  this.setState( { loading: false, error: 'No Posts Found' } );
                }
              } )
              .catch( err => this.setState( { loading: false, error: err.response.data.message } ) );
          } )
        }
    

        render() {

      
            const {posts} = this.state;
            console.log(posts);
               return (
                
                   <div class="GenderBlogContent">
                   <h1> Gender Blogs</h1>
                   <p> Learn about the experiences of transgender people from trans people!</p>
                   {posts.length ? (
                   <div className="bloglistcontainer">
                       {posts.map(post => (
                           <div key={post.id} className="blogcard">
                            <div className = "left">
                           <div className="title">
                           {renderHTML(post.title.rendered)}
                           </div>
                           <div className="subtitle">
                           {renderHTML(post.acf.subheading)}
                           </div>
                           </div>
                           <div className = "buttonblog">
                             <Link to = {post.acf.link}> Read </Link>  
                          

                            </div>
                                                     
                           
                           </div>
                       ))}
                   </div>
                   ): '' }
                    
                   </div>
               )
           }
       }
       
       export default GenderBlog;